// extracted by mini-css-extract-plugin
export default {"dropdownIcon":"DropdownIndicator_dropdownIcon__pwN6Q"};